import React from "react";

const Title = ({ title, description, handleSelectLanguage, register }) => {
  return (
    <>
      <div className="flex md:flex-row flex-col justify-between">
        <h4 className="text-xl font-medium dark:text-gray-300 m-0">{title}</h4>
        <p className="mb-0 text-sm dark:text-gray-300">{description}</p>
      </div>
    </>
  );
};

export default Title;
